import { UserProfileType } from "../types/profile";
export const developerProfileTypes = [
    {
        value: UserProfileType.DEVELOPER,
        label: "Developer",
    },
    {
        value: UserProfileType.APPROVER,
        label: "Approver",
    },
    {
        value: UserProfileType.HSBC,
        label: "HSBC",
    },
];

export const contractorProfileTypes = [
    {
        value: UserProfileType.MAIN_CONTRACTOR,
        label: "Main contractor",
    },
    {
        value: UserProfileType.HSBC,
        label: "HSBC",
    },
];

export const allProfileTypes = [
    {
        value: UserProfileType.DEVELOPER,
        label: "Developer",
    },
    {
        value: UserProfileType.APPROVER,
        label: "Approver",
    },
    {
        value: UserProfileType.HSBC,
        label: "HSBC",
    },
    {
        value: UserProfileType.MAIN_CONTRACTOR,
        label: "Main contractor",
    },
];

export const generateProfileType = (origin: string) => {
    switch (origin) {
        case "DEVELOPER":
            origin = "Developer";
            break;
        case "APPROVER":
            origin = "Approver";
            break;
        case "HSBC":
            origin = "HSBC";
            break;
        case "MAIN_CONTRACTOR":
            origin = "Main contractor";
            break;
    }
    return origin;
};